import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: [],
  detailData: [],

  fetching: false,
  error: null,
};

export const creators = createActions({
  WORKINHAND_SUMMARY_REQUEST: (dimDate) => ({ dimDate }),
  WORKINHAND_DETAIL_REQUEST: (dimDate) => ({ dimDate }),
  WORKINHAND_SUCCESS: (payload) => payload,
  WORKINHAND_FAILURE: (payload) => payload,
});

const summaryReducer = (state) => {
  return { ...state, fetching: true, error: null };
};

const detailReducer = (state) => {
  return { ...state, fetching: true, error: null };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    WORKINHAND_SUMMARY_REQUEST: summaryReducer,
    WORKINHAND_DETAIL_REQUEST: detailReducer,
    WORKINHAND_SUCCESS: successReducer,
    WORKINHAND_FAILURE: failureReducer,
  },
  initState,
);
